import { 
    SET_LOADING,
    SET_MOBILE_NO,
    SET_USERDATA,
    SET_USERNAME,
    SET_USER_ID,
    SET_VERIFICATION_OTP
} from "../../actions/auth/types";

const INITIAL_STATE = {
    userId : "",
    verificationOtp : "",
    loading: false,
    userData: null,
    mobileNo: '',
    username: '',
}

const AuthReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_USER_ID: {
            return {
                ...state,
                userId: action.payload
            }
        }
        case SET_VERIFICATION_OTP: {
            return {
                ...state,
                verificationOtp : action.payload
            }
        }
        case SET_USERDATA: {
            return {
                ...state,
                userData: action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        case SET_USER_ID: {
            return {
                ...state,
                userId: action.payload
            }
        }
        case SET_MOBILE_NO: {
            return {
                ...state,
                mobileNo: action.payload
            }
        }
        case SET_USERNAME: {
            return {
                ...state,
                username: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

export default AuthReducer